import { useUiStore } from "src/components/main/uiStore";
// handle "/" in file name
import { useEffect, useMemo, useRef, useState } from "react";
import { LoaderFunctionArgs, redirect, useLoaderData, useLocation, useNavigate, useRevalidator } from "react-router-dom";
import { saveAs } from "file-saver";
import "codemirror/mode/php/php";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import "codemirror/addon/edit/matchbrackets"; // Import the addon
import "codemirror/addon/search/searchcursor"; // Import the addon
import "codemirror/addon/comment/comment"; // Import the addon
import { Controlled as CodeMirror } from "react-codemirror2";
import { Editor, TextMarker } from "codemirror";
//-------------------------------------------------
import { ReactComponent as MatchCase }  from "src/img/svg/matchCase.svg";
import { ReactComponent as MatchWholeWord }  from "src/img/svg/matchWholeWord.svg";
import { ReactComponent as ReplaceAll }  from "src/img/svg/replaceAll.svg";
import { ReactComponent as Replace }  from "src/img/svg/replace.svg";
import Modal from "src/components/common/Modal";
import FileIcon from "src/components/common/fileIcons";
import Footer from "src/components/common/frame/footer";
import { 
    OS, 
    detectOS, 
    myAxios, 
    scroll
} from "src/components/common/functions";
import { Link } from "react-router-dom";
export const invalidFileNameChars = ["\\" /* only this not allowed in linux */, "/", ":", "*", "?", "\"", "<", "<", "|"];
export const defaultFolder = "/test";
export const defaultFolders = [
    {label: "Construct Smarter", value: "/test"}, 
]
export const paramlists: Record<string, string[]> = {
    "path": [], 
    "searchBar": ["true"],
    "matchCase": ["true"],
    "matchWholeWold": ["true"],
    "showReplaceBar": ["true"],
    "searchQuery": [],
    "replaceQuery": [],
};
type item = { isFolder: boolean, path: string };
type ExtraKeys = Record<string, ((cm: Editor) => void)>;
export default function FileExplorer(){
    const defaultContent = useLoaderData()?.content ?? "";
    const navigate = useNavigate();
    const { type, filePath } = useLoaderData()
    const setShowLoader = useUiStore(state => state.setShowLoader);
    //-------------------------------------------------
    const showModal = type === "file";
    const fileName = useLoaderData()?.fileName ?? "";
    const data = useLoaderData()?.data ?? [];
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [filterWords, setFilterWords] = useState("");
    //-------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredData = data.filter((item: item) => filterWords === ""?true:JSON.stringify(item).toLowerCase().includes(filterWords));
    const currentPageItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    //-------------------------------------------------
    return (
        <>
            <div className = "cssContent pb8rem">
                <nav className = "d-flex align-items-center mt-2 mb-4">
                    <span className = "d-inline-flex align-items-center me-3 mb-2">
                        <label
                            children = "Search:"
                            htmlFor = "search"
                            className = "me-2"
                        />
                        <input
                            id = "search"
                            className = "form-control inline w-auto"
                            type = "text"
                            value = {filterWords}
                            onChange = {e => {
                                setFilterWords(e.currentTarget.value.toLowerCase());
                            }}
                        />
                    </span>
                    {filePath !== null?
                    <span className = "d-inline-flex align-items-center me-3 mb-2">
                        <label htmlFor = "path">Path:</label>
                        <select
                            id = "path"
                            className = "form-control w-auto ms-2"
                            value = {"/" + filePath.split("/")[1]}
                            onChange = {e => {
                                navigate({search: "?path=" + e.currentTarget.value});
                            }}
                        >
                            {defaultFolders.map((item, itemIndex) => <option key = {itemIndex} value = {item.value}>{item.label}</option>)}
                        </select>
                    </span>
                    :<></>}
                    <label className = "btn btn-primary me-3 mb-2" htmlFor = "file">
                        Upload Files
                        <input
                            id = "file"
                            type = "file"
                            multiple = {true}
                            className = "nodisplay"
                            onChange = {async e => {
                                const target = e.currentTarget;
                                const files = target.files;
                                if(!files || files.length === 0 || files[0].name === "") return;
                                const formData = new FormData();
                                for(const file of files){
                                    formData.append("files[]", file);
                                }
                                formData.append("action", "upload");
                                formData.append("filePath", filePath);
                                setShowLoader(true);
                                const res = await myAxios({ fileName: "server/fileExplorer.php", formData: formData });
                                setShowLoader(false);
                                if(!res) return;
                                // reva
                                target.value = "";
                            }}
                        />
                    </label>
                    <button
                        children = "Add File"
                        type = "button"
                        className = "btn btn-primary me-3 mb-2"
                        onClick = {async() => {
                            const userInput = window.prompt("The new file name:");
                            if(userInput === null || userInput === "") return;
                            for(let char of ["\\" /* only this not allowed in linux */, "/", ":", "*", "?", "\"", "<", "<", "|"]){
                                if(userInput.indexOf(char) > -1){
                                    if(char === "\"") window.alert(`${char} is not allowed for file name.`);
                                    else window.alert(`"${char}" is not allowed for file name.`);
                                    return;
                                }
                            }
                            const formData = new FormData();
                            formData.append("action", "createFile");
                            formData.append("filePath", filePath);
                            formData.append("fileName", userInput);
                            const res = await myAxios({ fileName: "server/fileExplorer.php", formData: formData })
                            if(!res) return;
                            // reva
                        }}
                    />
                    <button
                        children = "Add Folder"
                        type = "button"
                        className = "btn btn-primary me-3 mb-2"
                        onClick = {async() => {
                            const userInput = window.prompt("The new folder name:");
                            if(userInput === null || userInput === "") return;
                            for(let char of invalidFileNameChars){
                                if(userInput.indexOf(char) > -1){
                                    if(char === "\"") window.alert(`${char} is not allowed for folder name.`);
                                    else window.alert(`"${char}" is not allowed for folder name.`);
                                    return;
                                }
                            }
                            const formData = new FormData();
                            formData.append("action", "createFolder");
                            formData.append("filePath", filePath);
                            formData.append("fileName", userInput);
                            const res = await myAxios({ fileName: "server/fileExplorer.php", formData: formData })
                            if(!res) return;
                            // reva
                        }}
                    />
                </nav>
                {
                <>
                <div className = "h4 my-3">
                    {filePath !== null?
                    filePath.split("/").slice(1).map((part: string, partIndex: number, self: string[]) => 
                        <Link
                            children = {<span
                                children = {`/${part}`}
                                className = {partIndex === self.length - 1?"":"pointer text-decoration-underline"}
                            />}
                            type = "button"
                            key = {partIndex}
                            className = "text-success"
                            to = {{ search: `?path=/${filePath.split("/").slice(1).slice(0, partIndex + 1).join("/")}` }}
                        />
                    )
                    :null}
                </div>
                {!filteredData.length?<div className = "cssLoading">Empty</div>:
                currentPageItems.map((item: item, index: number) => 
                <div key = {index} className = "h5">
                    <span
                        className = {`pointer${item.isFolder?" text-primary":""}`}
                        onClick = {async () => {
                            if(item.isFolder) scroll(null);
                            navigate({search: "?path=" + filePath + "/" + item.path});
                            setCurrentPage(1);
                        }}
                    >
                        <FileIcon
                            fileType = {item.path.split(".").at(-1) ?? ""} 
                            isFolder = {item.isFolder} 
                            className = "me-2"
                        />
                        {item.path}
                    </span>
                    <span
                        className = "ms-2 btn btn-warning"
                        onClick = {async() => {
                            if(!window.confirm("Are you sure to rename this " + (item.isFolder?"folder":"file") + "?")) return;
                            const userInput = window.prompt(item.path + "\nupdated " + (item.isFolder?"folder":"file") + " name:", item.path);
                            if(userInput === null || userInput === "") return;
                            const formData = new FormData();
                            formData.append("action", "rename");
                            formData.append("filePath", filePath);
                            formData.append("fileName", item.path);
                            formData.append("newFileName", userInput);
                            //------------------------
                            setShowLoader(true);
                            const res = await myAxios({ fileName: "server/fileExplorer.php", formData: formData });
                            setShowLoader(false);
                            if(!res) return;
                            //------------------------
                            // reva
                        }}
                    >
                        rename
                    </span>
                    <span
                        className = "ms-2 btn btn-warning"
                        onClick = {async() => {
                            if(!window.confirm("Are you sure to copy this " + (item.isFolder?"folder":"file") + "?")) return;
                            const userInput = window.prompt(item.path + "\ncopied " + (item.isFolder?"folder":"file") + " name:");
                            if(userInput === null || userInput === "") return;
                            const formData = new FormData();
                            formData.append("action", "copy");
                            formData.append("filePath", filePath);
                            formData.append("fileName", item.path);
                            formData.append("newFileName", userInput);
                            //------------------------
                            setShowLoader(true);
                            const res = await myAxios({ fileName: "server/fileExplorer.php", formData: formData });
                            setShowLoader(false);
                            if(!res) return;
                            //------------------------
                            // reva
                        }}
                    >
                        copy
                    </span>
                    <span
                        className = "ms-2 btn btn-warning"
                        onClick = {async() => {
                            if(!window.confirm("Are you sure to move this " + (item.isFolder?"folder":"file") + "?")) return;
                            const userInput = window.prompt(item.path + "\nupdated " + (item.isFolder?"folder":"file") + " path:");
                            if(userInput === null || userInput === "") return;
                            const formData = new FormData();
                            formData.append("action", "move");
                            formData.append("filePath", filePath);
                            formData.append("fileName", item.path);
                            formData.append("newPath", userInput);
                            //------------------------
                            setShowLoader(true);
                            const res = await myAxios({ fileName: "server/fileExplorer.php", formData: formData });
                            setShowLoader(false);
                            if(!res) return;
                            //------------------------
                            // reva
                        }}
                    >
                        move
                    </span>
                    <span
                        className = "ms-2 btn btn-info"
                        onClick = {async() => {
                            const formData = new FormData();
                            formData.append("action", "download");
                            formData.append("filePath", filePath);
                            formData.append("fileName", item.path);
                            //------------------------
                            setShowLoader(true);
                            const res = await myAxios({ fileName: "server/fileExplorer.php", formData: formData, responseType: "blob" });
                            setShowLoader(false);
                            if(!res) return;
                            saveAs(res.data, item.isFolder?item.path + ".zip":item.path);
                        }}
                    >
                        download
                    </span>
                    <span
                        className = "ms-2 btn btn-info"
                        onClick = {async() => {
                            const formData = new FormData();
                            formData.append("action", "property");
                            formData.append("filePath", filePath + "/" + item.path);
                            //------------------------
                            setShowLoader(true);
                            const res = await myAxios({ fileName: "server/fileExplorer.php", formData: formData });
                            setShowLoader(false);
                            if(!res) return;
                            window.alert(res.data);
                            //------------------------
                        }}
                    >
                        property
                    </span>
                    <span
                        className = "ms-2 btn btn-danger"
                        onClick = {async() => {
                            if(!window.confirm("Are you sure to delete this " + (item.isFolder?"folder":"file") + "?")) return;
                            const formData = new FormData();
                            formData.append("action", "delete");
                            formData.append("filePath", filePath + "/" + item.path);
                            //------------------------
                            setShowLoader(true);
                            const res = await myAxios({ fileName: "server/fileExplorer.php", formData: formData });
                            setShowLoader(false);
                            if(!res) return;
                            //------------------------
                            // reva
                        }}
                    >
                        delete
                    </span>
                </div>)}
                </>}
                {filteredData.length?
                <Footer
                    length = {filteredData.length}
                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
            {showModal?
            <CodeEditor
                fileName = {fileName} 
                filePath = {filePath} 
                defaultContent = {defaultContent}
            />
            :<></>}
        </>
    )
}

function CodeEditor({
    fileName, 
    filePath, 
    defaultContent
}:{
    fileName: string,
    filePath: string,
    defaultContent: string
}){
    const platform = detectOS();
    const extraKeysMap: Record<OS, ExtraKeys> = {
        mac: {
            "Cmd-K": (cm) => {
            if (cm.listSelections().length > 0) {
                cm.toggleComment({ indent: true });
            }
            },
            "Cmd-S": () => handleSubmit(),
            "Cmd-F": () => openSearch(),
        },
        windows: {
            "Ctrl-K": (cm) => {
            if (cm.listSelections().length > 0) {
                cm.toggleComment({ indent: true }); // Comment the selection with indented comment mark
            }
            },
            "Ctrl-S": () => handleSubmit(),
            "Ctrl-F": () => openSearch(),
        },
        other: {
            
        }
    };
    const [content, setContent] = useState(defaultContent);
    const [initialContent, setInitialContent] = useState(defaultContent);
    const revalidator = useRevalidator();
    const navigate = useNavigate();
    const location = useLocation();
    const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const showSearchBar = params.get("searchBar") === "true"?true:false;
    const searchQuery = params.get("searchQuery") ?? ""; // null | String
    const matchCase = params.get("matchCase") === "true"?true:false;
    const matchWholeWold = params.get("matchWholeWold") === "true"?true:false;
    const replaceQuery = params.get("replaceQuery") ?? ""; // null | String
    const showReplaceBar = params.get("showReplaceBar") === "true"?true:false;
    const editorRef = useRef<Editor | null>(null);
    const searchBarInputRef = useRef<HTMLInputElement>(null);
    // const editorInstanceRef = useRef(null);
    const [markers, setMarkers] = useState<TextMarker[]>([]); // To store highlighted markers
    const [matchCount, setMatchCount] = useState(0);
    const [searchIndex, setSearchIndex] = useState(0);
    const typingTimeoutRef = useRef<number | null>(null);
    const [searchText, setSearchText] = useState(searchQuery);
    const handleSubmit = async() => {
        if(content === initialContent) return;
        const formData = new FormData();
        formData.append("action", "update");
        formData.append("filePath", filePath);
        formData.append("content", content);
        const res = await myAxios({ fileName: "server/fileExplorer.php", formData: formData });
        if(!res) return;
        setInitialContent(content);
    }
    const openSearch = () => {
        params.set("searchBar", "true");
        navigate({search: decodeURIComponent(params.toString())}, { replace: true });
        window.setTimeout(() => {
            searchBarInputRef.current?.focus();
            searchBarInputRef.current?.select();
        }, 0)
    }
    const toggleMatchCase = () => {
        if(showSearchBar){
            if(matchCase){
                params.delete("matchCase");
            }else{
                params.set("matchCase", "true");
            }
            navigate({search: decodeURIComponent(params.toString())}, { replace: true });
            setSearchIndex(0);
        }
    }
    const toggleMatchWholeWord = () => {
        if(showSearchBar){
            if(matchWholeWold){
                params.delete("matchWholeWold");
            }else{
                params.set("matchWholeWold", "true");
            }
            navigate({search: decodeURIComponent(params.toString())}, { replace: true });
            setSearchIndex(0);
        }
    };
    const closeIt = () => {
        if(content !== initialContent && !window.confirm(`Do you want to leave without saving the changes you made to "${filePath}"`)) return;
        navigate({search: "?path=" + filePath.split("/").slice(0, -1).join("/")});
    }
    useEffect(() => {
        const editor = editorRef.current;
        if(editor){
            editor.focus(); // Focus the editor
            // editor.setCursor({ line: 0, ch: 0 }); // Set cursor to the start
            const lastLine = editor.lastLine(); // Get the last line number
            const lastChar = editor.getLine(lastLine).length; // Get the last character in the last line
            editor.setCursor({ line: lastLine, ch: lastChar }); // Set the cursor at the end
        }
        revalidator.revalidate();
    }, [revalidator]);
    useEffect(() => {
        const getData = async() => {
            markers.forEach((marker) => marker.clear()); // Clear each marker
            const editor = editorRef.current; // Access the CodeMirror instance
            if(editor){
                const existingCursor = editor.getCursor();  // Get the current cursor position
                editor.setSelection(existingCursor, existingCursor); 
            }
            if(markers.length) setMarkers([]);
            setMatchCount(0);
            if(!editor || !searchQuery) return;
            // --------------------------------------------------------------------- 
            const regex = !matchWholeWold && !matchCase ? new RegExp(searchQuery.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "gi") : 
                matchWholeWold && !matchCase ? new RegExp(`\\b${searchQuery.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}\\b`, "gi") : 
                !matchWholeWold && matchCase ? new RegExp(searchQuery.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "g") : 
                new RegExp(`\\b${searchQuery.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}\\b`, "g");
            // --------------------------------------------------------------------- 
            const cursor = editor.getSearchCursor(regex);
            // Find and highlight the search result
            const newMarkers = [];
            let count = 0;
            while(cursor.findNext()){
                const marker = editor.markText(cursor.from(), cursor.to(), {className: searchIndex === count?"curHighlight":"highlight"});
                if(searchIndex === count){
                    // editor.setSelection(cursor.from(), cursor.to()); // Highlight the result
                    // const object = cursor.from();
                    // const fixedBarHeight = document.querySelector("#fixed-bar").offsetHeight;
                    editor.scrollIntoView(cursor.from()); // Scroll to the result
                    // cursor.from().scrollIntoView({ behavior: "smooth", block: "center" });
                    // const scrollContainer = editor.getScrollerElement();
                    // scrollContainer.scrollTop -= fixedBarHeight;
                }
                newMarkers.push(marker);
                count++;
            }
            setMarkers(newMarkers);
            setMatchCount(count);
        }
        getData();
    }, [searchQuery, matchCase, matchWholeWold, searchIndex, markers]);
    return (
        <Modal
            closeIt = {closeIt}
            title = {fileName}
            actionKey = {content !== initialContent ? "Update" : ""}
            handleFormSubmit = {handleSubmit}
        >
            {showSearchBar?
            <div
                id = "fixed-bar"
                style = {{
                    position: "sticky", 
                    overflowX: "auto",
                    top: 0, 
                    left: 0, 
                    width: "100%", 
                    backgroundColor: "#f0f0f0", 
                    padding: "3px", 
                    zIndex: 1, 
                    display: "flex",
                    alignItems: "center"
                }}
            >
                <div>
                    <span
                        className = "h4 py-0 px-2 fw-bold searchBarExpendStyle"
                        onClick = {e => {
                            e.currentTarget.classList.toggle("searchBarExpendRotate");
                            if(showReplaceBar){
                                params.delete("replaceQuery");
                                params.delete("showReplaceBar");
                            }else{
                                params.set("showReplaceBar", "true");
                            }
                            navigate({search: decodeURIComponent(params.toString())}, { replace: true });
                        }}
                    >{">"}</span>
                </div>
                <div style = {{
                    display: "flex", 
                    flexDirection: "column", 
                    alignItems: "flex-start",
                }}>
                    <div style = {{
                        display: "flex", 
                        alignItems: "center"
                    }}>
                        <input
                            ref = {searchBarInputRef}
                            type = "text"
                            className = "form-control flex-grow-1"
                            value = {searchText}
                            onChange = {(e) => {
                                const value = e.currentTarget.value;
                                setSearchText(value);
                                params.set("searchQuery", value);
                                if(typingTimeoutRef.current){
                                    window.clearTimeout(typingTimeoutRef.current);
                                };
                                if(value === ""){
                                    params.delete("searchQuery");
                                    navigate({search: decodeURIComponent(params.toString())}, { replace: true });
                                }else{
                                    typingTimeoutRef.current = window.setTimeout(async () => {
                                        params.set("searchQuery", value);
                                        navigate({search: decodeURIComponent(params.toString())}, { replace: true });
                                    }, 500);
                                }
                                
                                setSearchIndex(0);
                            }}
                            autoComplete = "off"
                            placeholder = "Find"
                            onBlur = {e => {e.currentTarget.placeholder = "Find"}}
                            onFocus = {e => {e.currentTarget.placeholder = "Find (↑↓ for history)"}}
                            onKeyDown = {(event) => {
                                if(event.key === "Enter"){
                                    event.preventDefault();
                                    if(searchIndex < matchCount - 1) setSearchIndex(searchIndex + 1);
                                    else setSearchIndex(0);
                                }
                            }}
                        /> 
                        {matchCount !== 0?<span className = "ms-3">{searchIndex + 1} of {matchCount}</span>:<span className = {"ms-3" + (searchQuery === ""?"":" text-danger")}>No results</span>}
                        <MatchCase
                            className = {`pointer inline ms-3 mb-0 ${matchCase?"bg-primary":""}`}
                            style = {{fill: matchCase?"white":""}}
                            onClick = {() => {
                                if(matchCase){
                                    params.delete("matchCase");
                                }else{
                                    params.set("matchCase", "true");
                                }
                                navigate({search: decodeURIComponent(params.toString())}, { replace: true });
                                setSearchIndex(0);
                            }}
                        />
                        <MatchWholeWord
                            className = {`pointer inline ms-3 mb-0 ${matchWholeWold?"bg-primary":""}`}
                            style = {{fill: matchWholeWold?"white":""}}
                            onClick = {() => {
                                if(matchWholeWold){
                                    params.delete("matchWholeWold");
                                }else{
                                    params.set("matchWholeWold", "true");
                                }
                                navigate({search: decodeURIComponent(params.toString())}, { replace: true });
                                setSearchIndex(0);
                            }}
                        />
                        <button children = "↑" type = "button" className = "noButtonStyle pointer h4 ms-4 handleHover" onClick = {() => {
                            if(searchIndex > 0) setSearchIndex(searchIndex - 1);
                        }}/>
                        <button children = "↓" type = "button" className = "noButtonStyle pointer h4 ms-4 handleHover" onClick = {() => {
                            if(searchIndex < matchCount - 1) setSearchIndex(searchIndex + 1);
                        }}/>
                        <button children = "❌" type = "button" className = "noButtonStyle pointer h4 ms-4 me-5 handleHover" onClick = {() => {
                            setSearchText("");
                            params.delete("searchBar");
                            params.delete("matchCase");
                            params.delete("matchWholeWold");
                            params.delete("showReplaceBar");
                            params.delete("searchQuery");
                            params.delete("replaceQuery");
                            navigate({search: decodeURIComponent(params.toString())}, { replace: true });
                            setSearchIndex(0);
                        }}/>
                    </div>
                    {showReplaceBar?
                    <div style = {{
                        display: "flex", 
                        alignItems: "center"
                    }}>
                        <input
                            type = "text"
                            className = "form-control"
                            value = {replaceQuery}
                            onChange = {(e) => {
                                const value = e.currentTarget.value;
                                if(value === "") params.delete("replaceQuery")
                                else params.set("replaceQuery", value);
                                navigate({search: decodeURIComponent(params.toString())}, { replace: true });
                            }}
                            autoComplete = "off"
                            placeholder = "Replace"
                            onBlur = {e => {e.currentTarget.placeholder = "Replace"}}
                            onFocus = {e => {e.currentTarget.placeholder = "Replace (↑↓ for history)"}}
                        /> 
                        <button children = {<Replace/>} type = "button" className = "noButtonStyle pointer h4 ms-4 handleHover" onClick = {() => {
                            const editor = editorRef.current; // Access the CodeMirror instance
                            if(!editor || !searchQuery) return;
                            // --------------------------------------------------------------------- 
                            const regex = !matchWholeWold && !matchCase ? new RegExp(searchQuery.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "gi") : 
                                matchWholeWold && !matchCase ? new RegExp(`\\b${searchQuery.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}\\b`, "gi") : 
                                !matchWholeWold && matchCase ? new RegExp(searchQuery.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "g") : 
                                new RegExp(`\\b${searchQuery.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}\\b`, "g");
                            // --------------------------------------------------------------------- 
                            const cursor = editor.getSearchCursor(regex);
                            let count = 0;
                            while(cursor.findNext()){
                                if(searchIndex === count){
                                    cursor.replace(replaceQuery);
                                    setMatchCount(matchCount - 1);
                                    markers[searchIndex].clear(); // clear current highlight
                                    markers.splice(searchIndex, 1); // remove marker element from array
                                    setMarkers(markers);
                                }else if(searchIndex + 1 === count){
                                    // the index is already updated from splice above
                                    markers[searchIndex] && markers[searchIndex].clear(); // clear impending mark
                                    if(replaceQuery !== ""){
                                        markers[searchIndex] = editor.markText(cursor.from(), cursor.to(), {className: "curHighlight"}); // apply new highlight
                                        editor.scrollIntoView(cursor.from()); // Scroll to the result
                                    }

                                }else if(searchIndex + 2 === count){
                                    if(replaceQuery === ""){
                                        markers[searchIndex] = editor.markText(cursor.from(), cursor.to(), {className: "curHighlight"}); // apply new highlight
                                        editor.scrollIntoView(cursor.from()); // Scroll to the result
                                    }
                                }
                                count++;
                            }
                            if(searchIndex >= matchCount - 1) setSearchIndex(0);
                        }}/>
                        <button children = {<ReplaceAll/>} type = "button" className = "noButtonStyle pointer h4 ms-4 handleHover" onClick = {async() => {
                            markers.forEach((marker) => marker.clear()); // Clear each marker
                            const editor = editorRef.current; // Access the CodeMirror instance
                            if(!editor || !searchQuery) return;
                            // --------------------------------------------------------------------- 
                            const regex = !matchWholeWold && !matchCase ? new RegExp(searchQuery.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "gi") : 
                                matchWholeWold && !matchCase ? new RegExp(`\\b${searchQuery.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}\\b`, "gi") : 
                                !matchWholeWold && matchCase ? new RegExp(searchQuery.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "g") : 
                                new RegExp(`\\b${searchQuery.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}\\b`, "g");
                            // --------------------------------------------------------------------- 
                            const cursor = editor.getSearchCursor(regex);
                            while(cursor.findNext()){
                                cursor.replace(replaceQuery);
                                if (replaceQuery === ""){
                                    cursor.findNext();
                                }
                              }
                            setMatchCount(0);
                            setSearchIndex(0);
                            setMarkers([]);
                        }}/>
                    </div>
                    :<></>}
                </div>
            </div>
            :<></>}
            <CodeMirror
                // editorDidMount = {(editor) => {
                    // editorInstanceRef.current = editor; // Save the actual CodeMirror instance
                    // console.log("Editor instance options:", editor.options); // Log options to debug
                // }}
                editorDidMount = {(editor) => {
                    editorRef.current = editor;
                }}
                options = {{
                    mode: "php",
                    theme: "material",
                    lineNumbers: true, 
                    indentWithTabs: false, // Use spaces instead of actual tab characters
                    smartIndent: false, 
                    indentUnit: 4, 
                    matchBrackets: true, 
                    extraKeys: {
                        ...extraKeysMap[platform], 
                        "Tab": (cm) => {
                            if(cm.somethingSelected()){
                            cm.indentSelection("add"); // Indent the selected lines
                            }else{
                            cm.replaceSelection("    ", "end"); // Insert 4 spaces
                            }
                        },
                        "Shift-Tab": (cm) => cm.indentSelection("subtract"), // Unindent selected lines
                        "Enter": (cm) => {
                            const cursor = cm.getCursor(); // Get the current cursor position
                            const line = cm.getLine(cursor.line) ; // Get the content of the current line
                            const match = line.match(/^\s*/);
                            const leadingWhitespace = match ? match[0] : ""; // Extract leading spaces/tabs
                            cm.replaceSelection("\n" + leadingWhitespace, "end"); // Insert a newline and preserve the indentation
                        },
                        "Esc": () => closeIt(),
                        "Alt-C": () => toggleMatchCase(),
                        "Alt-W": () => toggleMatchWholeWord(),
                        fallthrough: "default" // Let other shortcuts work
                    }
                }}
                value = {content}
                onBeforeChange = {(editor, data, value) => {
                    setContent(value);
                }}
            />
        </Modal>
    );
}

export async function fileExplorerLoader({ request }:LoaderFunctionArgs) {
  const url = new URL(request.url);
  const params = url.searchParams;
  const filePath = params.get("path") ?? "";
  const formData = new FormData();
  formData.append("action", "read");
  formData.append("filePath", filePath);
  const res = await myAxios({
    fileName: "server/fileExplorer.php",
    formData
  });
  if (!res) {
    throw new Response("Failed to load file explorer", { status: 500 });
  }
  const result = res.data;
  /* ------------------ dir 逻辑 ------------------ */
  if (result.type === "dir") {
    if (result.isFallBack) {
      throw redirect(`?path=${defaultFolder}`);
    }
    const keys = Array.from(params.keys());
    if (keys.length !== 1) {
      throw redirect(`?path=${filePath}`);
    }
    return {
      type: "dir",
      filePath,
      data: result.content
    };
  }

  /* ------------------ file 逻辑 ------------------ */
  if (result.type === "file") {
    const cleanParams = new URLSearchParams(params);
    cleanParams.forEach((value, key, parent) => {
      if (
        !(key in paramlists) ||
        (paramlists[key].length && !paramlists[key].includes(value)) ||
        value === ""
      ) {
        parent.delete(key);
      }
    });
    const cleanSearch = cleanParams.toString();
    if (cleanSearch !== params.toString()) {
      throw redirect(`?${cleanSearch}`);
    }
    return {
      type: "file",
      filePath,
      fileName: filePath.split("/").at(-1),
      content:
        typeof result.content === "string"
          ? result.content
          : JSON.stringify(result.content)
    };
  }
  throw new Response("Unknown response type", { status: 500 });
}